export function paginateArray(array, pageSize, pageNumber) {
  var numItems = array.length;
  var indexStart = (pageNumber - 1) * pageSize;
  var indexEnd = numItems;
  if (pageSize < numItems) {
    indexEnd = pageSize * pageNumber;
    if (indexEnd > numItems) {
      indexEnd = numItems;
    }
  }
  return array.slice(indexStart, indexEnd);
}
